/**
 * Open shipment document screens in new tabs via URL path/query (not router state).
 */

const appendParam = (params, key, value) => {
    if (value == null || value === "") return;
    params.set(key, String(value));
};

/**
 * @param {"Dock Receipt" | "AR/AP" | "MBL" | string} type
 * @param {{ id?: string|number; fileNumber?: string }} shipment
 * @returns {string | null} App-relative path, or null if booking id is missing.
 */
export function getShipmentDocumentPath(type, shipment) {
    const bookingId = shipment?.id;
    if (!bookingId) return null;

    const fileNumber = shipment?.fileNumber;

    switch (type) {
        case "Dock Receipt": {
            const params = new URLSearchParams();
            appendParam(params, "fileNumber", fileNumber);
            const qs = params.toString() ? `?${params.toString()}` : "";
            return `/dock-receipt/${bookingId}${qs}`;
        }
        case "AR/AP":
            return `/job-costing/${bookingId}`;
        case "MBL": {
            const params = new URLSearchParams();
            appendParam(params, "bookingId", bookingId);
            appendParam(params, "fileNumber", fileNumber);
            return `/mbl?${params.toString()}`;
        }
        default:
            return null;
    }
}

/**
 * @param {"Dock Receipt" | "AR/AP" | "MBL" | string} type
 * @param {{ id?: string|number; fileNumber?: string }} shipment
 */
export function openShipmentDocumentInNewTab(type, shipment) {
    const path = getShipmentDocumentPath(type, shipment);
    if (!path) return;

    window.open(
        `${window.location.origin}${path}`,
        "_blank",
        "noopener,noreferrer",
    );
}
